import {Dialog, DialogActions, DialogContent, Divider, Grid, Typography} from "@mui/material";
import Button from "@mui/material/Button";
import React, {useEffect} from "react";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup/dist/yup";
import {RequiredNumberSchema, RequiredSchema} from "../../../../../utils/validations";
import {
    ClientSolicitationFlow,
    ClientSolicitationFlowFields,
    ClientSolicitationFlowForm
} from "../../../../../types/flow/flowData";
import {ControlledDatePicker, ControlledTextField} from "../../../../../components/forms";
import {HttpSolicitationFlow} from "../../../../../http/flow/httpFlow";
import {EntityWithIdFields} from "../../../../../types/baseEntities";
import BaseDialogTitle from "../../../../../components/dialog/BaseDialogTitle";
import * as yup from "yup";
import useAxios from "../../../../../hooks/useAxios";

interface DialogNewEconomicSituationProps {
    open: boolean,
    onClose: () => void,
    onSubmit: () => void,
    solicitationId: number,
    flowEdit?: ClientSolicitationFlow
}


const DialogNewEconomicSituation = ({open, onClose, onSubmit, solicitationId, flowEdit}: DialogNewEconomicSituationProps) => {
    const FlowSchema = yup.object().shape({
        [ClientSolicitationFlowFields.Date]: RequiredSchema,
        [ClientSolicitationFlowFields.Sales]: RequiredNumberSchema,
        [ClientSolicitationFlowFields.Incomes]: RequiredNumberSchema
    })
    
    const { control, handleSubmit, reset } = useForm<ClientSolicitationFlowForm>({
        resolver: yupResolver(FlowSchema)
    })
    
    const {fetchData} = useAxios()
    
    const handleClose = () => {
        reset(undefined)
        onClose()
    }

    useEffect(() => {
        if (open && flowEdit) reset({
            [ClientSolicitationFlowFields.Date]: new Date(flowEdit[ClientSolicitationFlowFields.Date]),
            [ClientSolicitationFlowFields.Sales]: flowEdit[ClientSolicitationFlowFields.Sales],
            [ClientSolicitationFlowFields.Incomes]: flowEdit[ClientSolicitationFlowFields.Incomes]
        })
        if (open && !flowEdit) reset({
            [ClientSolicitationFlowFields.Date]: null,
            [ClientSolicitationFlowFields.Sales]: null,
            [ClientSolicitationFlowFields.Incomes]: null
        })
    }, [open, flowEdit]);
    
    const onSubmitDialog = (data: ClientSolicitationFlowForm) => {
        // @ts-ignore
        const dateFormatted = new Date(data[ClientSolicitationFlowFields.Date])
        
        dateFormatted.setDate(1)

        const year = dateFormatted.getUTCFullYear();
        const month = ('0' + (dateFormatted.getUTCMonth() + 1)).slice(-2); // Sumamos 1 al mes ya que en JavaScript los meses van de 0 a 11
        const newDateString = `${year}-${month}-01T00:00:00.000Z`;
        
        const submitData: ClientSolicitationFlowForm = {
            ...data,
            [ClientSolicitationFlowFields.Date]: new Date(newDateString)
        }
        
        if (flowEdit) {
            fetchData(
                () => HttpSolicitationFlow.update(solicitationId, flowEdit[EntityWithIdFields.Id], submitData)
            ).then(() => onSubmit()).finally(() => handleClose())
        }else{
            fetchData(
                () => HttpSolicitationFlow.insert(solicitationId, submitData)
            ).then(() => onSubmit()).finally(() => handleClose())
        }
    }

    return (
        <Dialog open={open} onClose={handleClose} maxWidth={'md'} fullWidth>
            <BaseDialogTitle title={flowEdit ? 'Editar movimiento' : 'Nuevo movimiento'} onClose={handleClose} />
            <Divider />
            <form onSubmit={handleSubmit(onSubmitDialog)}>
                <DialogContent>
                    <Grid container justifyContent={'center'} spacing={4}>
                        {
                            !flowEdit &&
                            <Grid item xs={12}>
                                <Typography fontSize={16} textAlign={'center'}>Ingrese los datos solicitados a continuación para crear el movimiento</Typography>
                            </Grid>
                        }
                        <Grid item xs={3} justifyContent={'center'}>
                            <ControlledDatePicker
                                name={ClientSolicitationFlowFields.Date}
                                label='Periodo'
                                control={control}
                                views={['month', 'year']}
                                format={'MM/yyyy'}
                                helperText={'Formato: MM/YYYY'}
                            />
                        </Grid>
                        <Grid item xs={4.5} justifyContent={'center'}>
                            <ControlledTextField name={ClientSolicitationFlowFields.Incomes} 
                                                 label='Monto de Compras (Sin IVA)' 
                                                 control={control}
                                                 fullWidth
                                                 currency
                            />
                        </Grid>
                        <Grid item xs={4.5} justifyContent={'center'}>
                            <ControlledTextField name={ClientSolicitationFlowFields.Sales} 
                                                 label='Monto de Ventas (Sin IVA)' 
                                                 control={control}
                                                 fullWidth
                                                 currency
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button color='primary' variant='contained' type='submit'>Guardar</Button>
                </DialogActions>
            </form>
        </Dialog>
    )
}


export default DialogNewEconomicSituation